import { useSelector } from "react-redux";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

import "./Stepper.css";

import { useTranslation } from "react-i18next";

/*
 STEPPER:
      - contains the four steps 
        1 -> Prácticas
        2 -> Teoría
        3 -> Extras
        4 -> Resumen
      and the active one changes depending on the selected screen number
*/

export default function StepperComponent() {
  const activeStep = useSelector((state) => state.stepper.activeStep);

  const [t, i18n] = useTranslation("global");

  const steps = [
    t("STEPPER.steps.1"), //Prácticas
    t("STEPPER.steps.2"), // Teoría
    t("STEPPER.steps.3"), // Extras
    t("STEPPER.steps.4"), // Resumen
  ];

  return (
    <>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </>
  );
}
